module.exports = __webpack_public_path__ + "img/calendar4-week.03fe48a7.svg";